import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-76f7d7ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { style: {"margin-top":"1vw","font-weight":"1000","font-size":"35px"} }
const _hoisted_3 = { class: "subject-holder" }
const _hoisted_4 = { style: {"margin-top":"0px"} }

import res from "../data/text.json";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "SummaryOfSkills",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const resume = res;

return (_ctx: any,_cache: any) => {
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!
  const _directive_motion_slide_visible_once_top = _resolveDirective("motion-slide-visible-once-top")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_2, [
      _createTextVNode(" Summary of Skills ")
    ])), [
      [_directive_motion_slide_visible_once_left]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resume).summaryOfSkills, (subject) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "subject-object",
          key: subject.title
        }, [
          _createElementVNode("h3", null, _toDisplayString(subject.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subject.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item
            }, [
              _createElementVNode("p", _hoisted_4, "■ " + _toDisplayString(item), 1)
            ]))
          }), 128))
        ]))
      }), 128))
    ])), [
      [_directive_motion_slide_visible_once_top]
    ])
  ]))
}
}

})